import { REDIS_KEY_SEPARATOR } from '@headless-workspace/config';

const createCacheKey = (key: string, params: Record<string, unknown>) => {
    return {
        key,
        params: Object.keys(params)
            .sort((a, b) => a.localeCompare(b))
            .reduce(
                (sorted, k) => {
                    sorted[k] = params[k];
                    return sorted;
                },
                {} as Record<string, unknown>,
            ),
    };
};

const createTags = (prefix: string, key: string, params: Record<string, unknown>) => {
    return [
        prefix,
        `${prefix}${REDIS_KEY_SEPARATOR}${key}`,
        ...Object.entries(params).map(([k, v]) => `${k}${REDIS_KEY_SEPARATOR}${v}`),
    ];
};

export const CachingHelpers = {
    createCacheKey,
    createTags,
};
